import { AccordionItem, AccordionStep } from '@hb/domain';
import * as content from '@hb/hypotheken-berekening.content.json';
import { AccordionStateService } from '@hb/services/accordion-state/accordion-state.service';
import { StoreService } from '@hb/services/store/store.service';

import {
    AfterViewInit,
    Component,
    CUSTOM_ELEMENTS_SCHEMA,
    ElementRef,
    inject,
    OnDestroy,
    OnInit,
    QueryList,
    ViewChildren
} from '@angular/core';
import { Subscription, distinctUntilChanged } from 'rxjs';
import { CommonModule } from '@angular/common';

import { ApContentModule, ApContentService } from '@ap/content';
import { AvailableIcons } from '@ap/icon';
import { ApAnalyticsModule } from '@ap/analytics';
import { ApErrorModule } from '@ap/error';

import '@asn/accordion';

@Component({
    selector: 'main-accordion',
    templateUrl: './main-accordion.component.html',
    standalone: true,
    imports: [ApAnalyticsModule, ApContentModule, ApErrorModule, CommonModule],
    schemas: [CUSTOM_ELEMENTS_SCHEMA]
})
export class MainAccordionComponent implements OnInit, OnDestroy, AfterViewInit {
    private readonly contentService = inject(ApContentService);
    private readonly storeService = inject(StoreService);
    private readonly accordionStateService = inject(AccordionStateService);

    accordionList: AccordionItem[] = [];
    stepSubscription: Subscription;

    @ViewChildren('accordionItem') accordionItemElements: QueryList<ElementRef<HTMLElement>>;

    ngOnInit(): void {
        this.contentService.addContentItems(content);
        this.accordionStateService.getAccordionState().subscribe((accordionState) => {
            this.accordionList = accordionState;
        });

        this.storeService.getHasCoApplicant().subscribe((hasCoApplicant) => {
            const propertyItem = this.accordionList.find((item) => item.step === AccordionStep.PROPERTY);
            if (!propertyItem) {
                return;
            }
            propertyItem.title = hasCoApplicant
                ? this.contentService.get('main.main-accordion.together.property.title')
                : this.contentService.get('main.main-accordion.single.property.title');
        });
    }

    ngOnDestroy(): void {
        this.stepSubscription?.unsubscribe();
    }

    ngAfterViewInit(): void {
        this.stepSubscription = this.accordionStateService
            .getOpenAccordionStepObservable()
            .pipe(distinctUntilChanged())
            .subscribe((step: AccordionStep) => {
                const accordionItems = document.querySelectorAll('asn-accordion-item');
                accordionItems.forEach((item: any) => {
                    item.initOpen = false;
                });
                const itemToOpen: any = document.querySelector(`asn-accordion-item[data-step="${step.toString()}"]`);
                if (itemToOpen) {
                    itemToOpen.initOpen = true;
                }
            });
    }

    setOpenStep(id: number): void {
        this.accordionStateService.setManualOpened(id);
    }

    showStep(step: AccordionStep): boolean {
        return !(
            (this.accordionStateService.getDisplayFirstStepOnly() && step !== AccordionStep.INCOME) ||
            !this.accordionStateService.getStepIsVisible(step)
        );
    }

    displayFirstStepOnly(step: AccordionStep): boolean {
        return this.accordionStateService.getDisplayFirstStepOnly() && step === AccordionStep.INCOME;
    }

    getIcon(item: AccordionItem): AvailableIcons {
        if (this.displayFirstStepOnly(item.step)) {
            return null;
        }
        if (this.accordionStateService.getStepIsFinished(item.step)) {
            return 'checkmark';
        }
        return item.icon;
    }
}
